import(/* webpackMode: "eager" */ "/app/developer-portal/src/app/page.tsx")